import { UsedProductIndustry } from "@/@types";
import { UsedProductIndustryResponse } from "../usedProduct/models/UsedProductIndustryResponse";

export function mapUsedProductsIndustry (industry: UsedProductIndustryResponse): UsedProductIndustry {
    return {
        title: industry.title,
        slug: industry.slug,
    };
}